import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '资讯导航',
    links: [
      { label: '个人资料', path: '/category/profile' },
      { label: '出道经历', path: '/category/debut' },
      { label: '代表作品', path: '/category/works' },
      { label: '写真集', path: '/category/photobook' },
      { label: '最新动态', path: '/category/news' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '粉丝社区', path: '/category/community' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '日本偶像资讯', path: '#', isExternal: true },
      { label: '写真集推荐', path: '#', isExternal: true },
      { label: '日剧速递', path: '#', isExternal: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/50">
      <div className="w-full px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
                桥本有菜
              </span>
              <span className="text-sm text-foreground-500 ml-2 whitespace-nowrap">官方资料站</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              桥本有菜官方资料站是华语地区最全面的桥本有菜资讯平台，致力于为粉丝提供最新、最全的信息服务。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-800 mb-4 whitespace-nowrap">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) =>
                  link.isExternal ? (
                    <li key={link.label}>
                      <a
                        href={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                        rel="nofollow noopener noreferrer"
                        target="_blank"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 桥本有菜官方资料站. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-base"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-base"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}